













































































import Vue from 'vue';
import { Component } from 'vue-property-decorator';
import { PaginationModel, VHeaders } from '@/models/pagedlistmodel';
// import { Validator } from 'vee-validate';
import { Base } from '@/components/common/base';
import { TenantInfo } from '@/models/inventory/vehiclerevivestep';
import { Richtext } from 'dhx-richtext';
import 'dhx-richtext/codebase/richtext.css';
import { IDialogOption } from '@/models/dialog';
import { formSubmit } from '@servicestack/client';
import { LoginModel } from '@/models/admin/users';
import * as marked from 'marked';
import * as dhx from 'dhx-richtext';
import { storeService, vehicleReconStepService } from '@/shared';

@Component({
  props: ['methodName'],
  components: {
    Grid: () => import('@/components/common/app.grid.vue'),
    AppDialog: () => import('@/components/common/app.dialog.vue'),
    Richtext,
  },
  computed: {
    previewText() {
      return marked(this.md_text);
    },
    methodtoCall: {
      get() {
        return this.$props.methodName;
      },
    },
  },
})
export default class AddChatGptInstruction extends Base {
  public loading: boolean = false;
  public pagination = new PaginationModel('createdAt', true, 5);
  public items: any[] = [];
  public dialog: boolean;
  public instructionTextToDisplay: string = '';
  public recordKey: string;
  public instructionText: string = '';
  public instructionId: string = '';
  public storeId: number = 0;
  public tenantId: number = 0;
  public enterpriseId: number = 0;
  public html: string = '';
  public disableSaveInstruction: boolean = false;

  public css: string = '';
  public mode: { type: string; default: 'classic' };
  public value: string = '';

  public dataType: { type: string; default: 'markdown' };
  public richtext: Richtext;
  public markdown: string = '';
  public isDefaultInstruction: boolean = false;

  public conditionItems: any[] = [
    { value: 'EQUALSTO', text: 'Equals To' },
    { value: 'NOTEQUALSTO', text: 'Not Equals To' },
    { value: 'CONTAINS', text: 'Contains' },
    { value: 'GREATERTHAN', text: 'Greater Than' },
    { value: 'LESSTHAN', text: 'Less Than' },
  ];
  public rulesNameLoading: boolean = false;
  public showRulesSection: boolean = true;

  public rulesNameItems: any[] = [];

  public rules: any[] = [];
  public rulesModel: any[] = [];
  public tenantInfo: TenantInfo = {
    tenantId: 0,
    enterpriseId: 0,
    storeId: 0,
  };

  public beforeDestroy() {
    const buttons = [];
    this.$emit('updateToolBar', buttons);
  }
  public callMethod(methodName): void {
    if (methodName === 'backToList') {
      if (history.state && history.length > 1) {
        history.back();
      }
    }
    this.resetMethodName(methodName);
  }
  public resetMethodName(methodName): void {
    if (methodName !== '') {
      this.$emit('resetMethodName', methodName);
    }
  }
  public updateToolBar(): void {
    const buttons: any = [];
    buttons.push({
      id: '0',
      type: 'button',
      title: "Back",
      disabled: false,
      visible: true,
      class: 'btn',
      label: "Back",
      click: 'backToList',
      icon: 'fas fa-arrow-left',
    });
    this.$emit('updateToolBar', buttons);
  }

  public created() {
    dhx.i18n.setLocale('richtext', this.$t('richText'));
    this.getChatGptRules();
  }

  public mounted() {
    this.richtext = new Richtext(this.$refs.container, {
      mode: this.mode,
      css: this.css,

    });

    this.updateToolBar();
    this.$watch('methodtoCall', (newVal, oldVal) => {
      if (newVal) {
        this.callMethod(newVal);
      }
    });

  }

  public async saveInstruction(): Promise<void> {
    try {
      if (!this.isDefaultInstruction) {
        if (this.rules.length == 0) {
          this.showAlert(
            false,
            'Please enter atleast one rule for non default template'
          );
          return;
        }
        if (!(await this.validateFormByScope('ruleScope'))) {
          return;
        }

      }

      this.instructionText = this.richtext.getValue('markdown');
      if (!this.instructionText) {
        this.showAlert(
          false,
          'Instruction text is empty'
        );
        return;
      }
      this.disableSaveInstruction = true;

      if (!this.$route.params.storeId) {
        this.showAlert(
          false,
          'Store Not found'
        );
        return;
      }

      this.storeId = Number(this.$route.params.storeId);
      if (this.rules.length > 0) {
        this.rulesModel = this.rules;
        this.rulesModel = this.rulesModel.map((x) => x.name = x.name.ruleName);
      }
      if (this.isDefaultInstruction) {
        this.rulesModel = [];
      }

      await storeService.addChatGptTemplate(
        this.storeId,
        this.instructionText,
        this.isDefaultInstruction,
        this.rules
      );

      this.instructionText = '';
      this.markdown = '';
      this.richtext.setValue(this.markdown, this.dataType);

      this.showAlert(true, 'Instruction Added Successfully');
      if (history.state && history.length > 1) {
        history.back();
      }
    } finally {
      this.disableSaveInstruction = false;
    }
  }

  public updatePaging(paging: any) {
    this.pagination = paging;
  }

  public addRowToTable() {
    this.rules.push({
      name: '',
      condition: '',
      value: '',
    });
  }

  public removeLineItems(model): void {
    const index = this.rules.indexOf(model);
    if (index > -1) {
      this.rules.splice(index, 1);
    }
  }

  public async getChatGptRules(): Promise<void> {
    try {
      this.rulesNameLoading = true;
      const response = await storeService.getChatGptvehicleRules();
      this.rulesNameItems = response.results;
    } finally {
      this.rulesNameLoading = false;
    }
  }

  public ToggleRuleSection() {
    if (this.isDefaultInstruction) {
      this.showRulesSection = false;
    } else {
      this.showRulesSection = true;
    }
  }

}
